import React, { Component } from 'react';
import { Accordion, Button } from 'react-bootstrap';
import _ from 'lodash';
import RadioButton from '../../../components/RadioButton/RadioButton';
import DataSlider from './DataSlider';
import windowSize from '../../../util/windowSize';
import { FILTER_MIN_WIDTH } from '../../Common/globals';

import DashboardAccordion from './DashboardAccordion';

// Import Style
import '../../../components/Filter/Filter.scss';

export class ReportFilter extends Component {

  static defaultProps = {
    onApply: () => {}
  }

  constructor(props) {
    super(props);
    this.count = 0;
    this.state = {
      rangeOptions: [
        { label: "Week", value: "lastWeek", number: 1, type: "week" },
        { label: "2 weeks", value: "last2Week", number: 2, type: "week" },
        { label: "Month", value: "lastMonth", number: 1, type: "month" },
        { label: "Quarter", value: "last3Month", number: 3, type: "month" }
      ],
      expandedFilters: ['controls', 'dateRange', 'threshold'],
      dragging: false,
      rel: null,
      right: null
    };
    this.handleRef = React.createRef();
  }

  componentDidMount() {
    this.syncDashboardState();
    if (this.props.windowWidth) {
      this.handleScreenResize();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.dashboards, this.props.dashboards)) {
      this.syncDashboardState();
    }

    // Handle window resize
    if (prevProps.windowWidth !== this.props.windowWidth) {
      this.handleScreenResize();
    }

    // Add/remove mouse event listeners for resize dragging
    if (this.state.dragging && !prevState.dragging) {
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    } else if (!this.state.dragging && prevState.dragging) {
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  handleScreenResize = () => {
    if (this.props.windowWidth > 992) {
      const size = window.valueStreamFilterWidth || FILTER_MIN_WIDTH;
      this.updateSizes(size);
    } else {
      this.updateSizes();
    }
  };

  onMouseDown = e => {
    // only left mouse button
    if (e.button !== 0) {
      return false;
    }

    const pos = this.handleRef.current.getBoundingClientRect();
    this.setState({
      dragging: true,
      rel: {
        x: e.pageX - pos.left,
        y: e.pageY - pos.top
      }
    });
    e.stopPropagation();
    e.preventDefault();
  };

  onMouseUp = e => {
    this.setState({ dragging: false });
    e.stopPropagation();
    e.preventDefault();
    // Trigger Highcharts resize if present
    if (window && window.hcEvents && window.hcEvents.resize) {
      for (let i = 0; i < window.hcEvents.resize.length; i++) {
        if (typeof window.hcEvents.resize[i] === 'function') {
          window.hcEvents.resize[i]();
        }
      }
    }
  };

  onMouseMove = e => {
    if (!this.state.dragging) {
      return false;
    }

    const right = window.innerWidth - e.pageX - this.state.rel.x;
    this.setState({ right });
    this.updateSizes(right);
    e.stopPropagation();
    e.preventDefault();
  };

  updateSizes = width => {
    const filter = document.getElementsByClassName('filter');
    const filterPositionTop = document.getElementsByClassName('filter-postion-top');
    const topHeader = document.getElementsByClassName('top_header');
    const notificationBar = document.getElementsByClassName('notification_bar');
    const reportWrap = document.getElementsByClassName('report-wrap');
    const report = document.getElementsByClassName('report');
    const cellFullscreen = document.querySelectorAll('.row-cell-list .cell.fullscreen');
    const noData = document.querySelectorAll('.row-cell-list .no_data');

    if (width >= FILTER_MIN_WIDTH && width <= 600) {
      window.valueStreamFilterWidth = width;
      for (let i = 0; i < filter.length; i++) {
        filter[i].style.width = `${width}px`;
      }
      for (let i = 0; i < filterPositionTop.length; i++) {
        filterPositionTop[i].style.width = `${width}px`;
      }
      for (let i = 0; i < topHeader.length; i++) {
        topHeader[i].style.marginRight = `${width}px`;
      }
      for (let i = 0; i < notificationBar.length; i++) {
        notificationBar[i].style.marginRight = `${width}px`;
      }
      for (let i = 0; i < reportWrap.length; i++) {
        if (reportWrap[i].classList.contains('execdashboard')) {
          reportWrap[i].style.marginRight = `${width}px`;
        }
      }
      for (let i = 0; i < report.length; i++) {
        if (report[i].classList.contains('execdashboard')) {
          report[i].style.marginRight = `${width}px`;
        }
      }
      for (let i = 0; i < cellFullscreen.length; i++) {
        cellFullscreen[i].style.right = `${width}px`;
      }
      for (let i = 0; i < noData.length; i++) {
        noData[i].style.right = `${width}px`;
      }
    } else if (!width) {
      // Reset to CSS defaults when on mobile
      window.valueStreamFilterWidth = null;
      for (let i = 0; i < filter.length; i++) {
        filter[i].style.width = '';
      }
      for (let i = 0; i < filterPositionTop.length; i++) {
        filterPositionTop[i].style.width = '';
      }
      for (let i = 0; i < topHeader.length; i++) {
        topHeader[i].style.marginRight = '';
      }
      for (let i = 0; i < notificationBar.length; i++) {
        notificationBar[i].style.marginRight = '';
      }
      for (let i = 0; i < reportWrap.length; i++) {
        reportWrap[i].style.marginRight = '';
      }
      for (let i = 0; i < report.length; i++) {
        report[i].style.marginRight = '';
      }
      for (let i = 0; i < cellFullscreen.length; i++) {
        cellFullscreen[i].style.right = '';
      }
      for (let i = 0; i < noData.length; i++) {
        noData[i].style.right = '';
      }
    }
  };

  syncDashboardState = () => {
    const { dashboards = [] } = this.props;
    const stateUpdate = {};

    Object.keys(this.state).forEach(key => {
      if (this.state[key]?.dashboardId && !dashboards.some(d => d._id === key)) {
        stateUpdate[key] = undefined;
      }
    });

    dashboards.forEach(d => {
      if (d._id) {
        stateUpdate[d._id] = {
          dashboardId: d._id,
          queueLists: d.queueLists || [],
          labels: d.filters?.labels || [],
          members: d.filters?.members || [],
          customFields: d.filters?.customFields || []
        };
      }
    });

    if (Object.keys(stateUpdate).length > 0) {
      this.setState(stateUpdate);
    }
  };

  handleUpdate = e => {
    this.setState(
      {
        [e.dashboardId]: e
      });
  };

  handleChange = e => {
    if (e.name === 'percentile') {
      this.props.changePercentile(e.value);
    }
    if (e.name === 'dateRange') {
      this.props.changeDateRange(e.value);
    }
  };

  changeThreshold = e => {
    this.props.changeThreshold(e);
  }; 

  applyFilters = isInitial => {
    if (this.props.onApply) {
      const currentDashboardIds = new Set(this.props.dashboards.map(d => d._id));
      const filteredState = {};
      Object.keys(this.state).forEach(key => {
        if (currentDashboardIds.has(key)) {
          filteredState[key] = this.state[key];
        }
      });
      this.props.onApply(filteredState, isInitial);
    }
  };

  handleFilterSelect = e => {
    this.setState({
      expandedFilters: e
    });
  }

  renderControls() {
    return (
     
      <Accordion.Item eventKey="controls" key="controls" uuid="controls" activeKey={true}>
        <Accordion.Header>
          <React.Fragment><span className='title'>Controls</span></React.Fragment>
        </Accordion.Header>
        <Accordion.Body>
          <Accordion
            onSelect={e => this.handleFilterSelect(e)}
            activeKey={this.state.expandedFilters} alwaysOpen>
            {this.renderDateRange()}
            {this.renderThreshold()}              
          </Accordion>
        </Accordion.Body>
      </Accordion.Item>
    
    );
  }

  renderThreshold() {
    return (
      <Accordion.Item eventKey='threshold' key="threshold" uuid="threshold" activeKey={true}>
        <Accordion.Header>
          <React.Fragment>Variation</React.Fragment>
        </Accordion.Header>
        <Accordion.Body>
          <DataSlider threshold={this.props.threshold} changeThreshold={this.changeThreshold} />
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  renderDateRange() {
    const { rangeOptions } = this.state;
    const { dateRange } = this.props;
    const dateRanges = _.map(rangeOptions, (d) => {
      return (        
        <RadioButton
          key={d.value}
          label={d.label}
          id="dateRange"
          name="dateRange"
          value={d.value}
          checked={dateRange === d.value}
          onChange={this.handleChange}
        />
      );
    });
    return (
      <Accordion.Item eventKey='dateRange' key="dateRange" uuid="dateRange">
        <Accordion.Header>
          <React.Fragment>Group by</React.Fragment>
        </Accordion.Header>
        <Accordion.Body>  
          <div>  
            {dateRanges}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  render() {
    const { dashboards, controls, loading } = this.props;

    const items = dashboards.map((dashboard, i) => {
      return (
        <Accordion.Item eventKey={`acc_${i}`} key={`acc_${i}`} uuid={`acc_${i}`}>
          <Accordion.Header>
            <React.Fragment><span className='title'>{dashboard.name}</span></React.Fragment>
          </Accordion.Header>
          <Accordion.Body>
            {!loading && (<DashboardAccordion dashboard={dashboard} onChange={this.handleUpdate} />)}
          </Accordion.Body>
        </Accordion.Item>
      );
    });
    return (
      <div className='resize_container'>
        <div className='resize_handle' onMouseDown={this.onMouseDown} ref={this.handleRef} />
        <div className='filter-postion-top'>
          <div className='btn-action'>
            <Button variant='primary' disabled={loading} onClick={() => this.applyFilters()}>
              Apply filters
            </Button>
          </div>
          <Accordion className='filter filter-panel'
            onSelect={e => this.handleFilterSelect(e)}
            activeKey={this.state.expandedFilters}
            alwaysOpen>
            {controls && !loading && this.renderControls()}
            {items}
          </Accordion>
        </div>
      </div>
    );
  }
}

export default windowSize(ReportFilter);
